import { Col, Image, Layout, Row } from "antd";
import * as React from "react";
import { Outlet } from "react-router-dom";
import { AstenaLayoutProps } from "../Interfaces/AstenaLayoutProps";
import BackGround from "../Assets/LoginBackground.png"

const AuthLayout: React.FC<AstenaLayoutProps> = (props) => {
    React.useEffect(() => {
        document.title = props.pageTitle;
    }, []);

    return (
        <Layout style={{ height: "100vh" }}>
            <Layout.Content style={{ height: "100%" }}>
                <Row style={{ height: "100%" }}>
                    <Col span={10}>
                        <Outlet />
                    </Col>
                    <Col span={14} style={{ display: "flex" }}>
                        <Image alt="Logo" src={BackGround} preview={false} style={{ height: "100%", objectFit: "cover" }} />
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );
};

export default AuthLayout;
